import React from "react";
import loader from "../../components/loader/loader";

const ViewFleet = ({ modalId, viewDetails }) => {
  const view = viewDetails ? viewDetails : "";
  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && view?._id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                    action="#"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">Fleet Details</h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Fleet Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.name}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Model</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.vehicle_model}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Year</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.year}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Color</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.color}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>License Plate</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.license_plate}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Fuel Type</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.fuel_type}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Registration Number</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.registration_no}
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </form>
                ) : (
                  loader()
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewFleet;
